import LoadingIcon from '@/assets/icons/loading.svg?react';
import { type IconComponentProps } from '@/components/types';

import styles from './styles.module.scss';

export function LoadingScreen({
  width = 52,
  height = 46,
  color = '#191960',
}: IconComponentProps) {
  return (
    <div className={styles.container}>
      <LoadingIcon
        className={styles.icon}
        width={width}
        height={height}
        color={color}
      />
    </div>
  );
}
